import { ReactComponent as RepeatIconSVG } from '@/assets/icons/RepeatIcon.svg';
import { SVGProps } from 'react';

const RepeatIcon = (props: SVGProps<SVGSVGElement>) => <RepeatIconSVG {...props} />;

export default RepeatIcon;
